
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 12c0 .529-.018 1.045-.053 1.545a.491.491 0 01-.493.455H9.546a.491.491 0 01-.493-.455 22.195 22.195 0 010-3.09.491.491 0 01.493-.455h4.908c.258 0 .475.197.493.455.035.5.053 1.016.053 1.545zM17.461 10a.509.509 0 00-.505.542 24.286 24.286 0 010 2.916.509.509 0 00.505.542h3.93a.483.483 0 00.482-.402 10.067 10.067 0 000-3.196.483.483 0 00-.482-.402h-3.93zM20.835 7.312c.17.318-.07.688-.431.688h-3.326a.509.509 0 01-.496-.412c-.314-1.572-.79-2.952-1.38-4.038-.232-.426.155-.985.603-.8 2.16.89 3.941 2.514 5.03 4.562zM14.495 7.405a.487.487 0 01-.48.595h-4.03a.487.487 0 01-.48-.595c.21-.892.476-1.686.78-2.356C11.13 3.193 11.885 3 12 3c.114 0 .871.193 1.715 2.05.304.669.57 1.463.78 2.355zM6.922 8c.242 0 .45-.174.496-.412.314-1.572.79-2.952 1.38-4.038.232-.426-.155-.985-.603-.8a10.038 10.038 0 00-5.03 4.562c-.17.318.07.688.431.688h3.326zM2.609 10a.483.483 0 00-.482.402 10.072 10.072 0 000 3.196.483.483 0 00.482.402h3.93c.293 0 .522-.25.505-.542a24.278 24.278 0 010-2.916.51.51 0 00-.505-.542h-3.93zM10.285 18.95c-.304-.669-.57-1.463-.78-2.355a.487.487 0 01.48-.595h4.03c.316 0 .553.288.48.595-.21.892-.476 1.686-.78 2.356C12.87 20.807 12.115 21 12 21c-.114 0-.871-.193-1.715-2.05zM7.418 16.412A.509.509 0 006.922 16H3.596c-.36 0-.6.37-.431.688a10.038 10.038 0 005.03 4.563c.448.184.835-.375.604-.801-.592-1.085-1.067-2.466-1.38-4.038zM20.835 16.688c.17-.318-.07-.688-.431-.688h-3.326a.509.509 0 00-.496.412c-.314 1.572-.79 2.953-1.38 4.038-.232.426.155.985.603.8a10.038 10.038 0 005.03-4.562z"}})])
          )
        }
      }
    